<template>
  <PrivacySection title="10. Diritti dell'Interessato">
    <p>
      Ai sensi del GDPR e del Codice Privacy, l'utente ha diritto di:
    </p>
    <ul>
      <li><strong>Accesso:</strong> ottenere conferma dell'esistenza di dati personali 
          che lo riguardano e accedere a tali dati</li>
      <li><strong>Rettifica:</strong> ottenere la correzione di dati personali inesatti 
          o incompleti</li>
      <li><strong>Cancellazione ("Diritto all'Oblio"):</strong> ottenere la cancellazione 
          dei dati personali quando non sono più necessari o quando il consenso è stato revocato</li>
      <li><strong>Limitazione del Trattamento:</strong> ottenere la limitazione del 
          trattamento dei dati personali in determinate circostanze</li>
      <li><strong>Portabilità dei Dati:</strong> ricevere i dati personali in un formato 
          strutturato e di uso comune e trasmetterli a un altro titolare del trattamento</li>
      <li><strong>Opposizione:</strong> opporsi al trattamento dei dati personali per 
          motivi legittimi</li>
      <li><strong>Revoca del Consenso:</strong> revocare il consenso in qualsiasi momento, 
          senza pregiudicare la liceità del trattamento basato sul consenso prima della revoca</li>
      <li><strong>Proposizione di Reclamo:</strong> proporre reclamo all'Autorità Garante 
          per la Protezione dei Dati Personali (www.garanteprivacy.it) se ritiene che 
          il trattamento dei suoi dati violi la normativa applicabile</li>
    </ul>
    <p>
      Per esercitare i propri diritti, l'utente può contattarci all'indirizzo email 
      <a href="mailto:info@appscontrini.it">info@appscontrini.it</a> o attraverso la 
      sezione "Contattaci" del sito web o dell'applicazione.
    </p>
    <p>
      <strong>Nota per l'applicazione mobile:</strong> Per eliminare i dati memorizzati 
      localmente sull'applicazione, l'utente può disinstallare l'applicazione dal proprio 
      dispositivo o utilizzare la funzione di cancellazione dati disponibile nelle impostazioni 
      dell'applicazione. Per informazioni dettagliate e per richiedere la cancellazione dei 
      dati conservati sui nostri server, consulta la pagina dedicata alla 
      <router-link to="/cancellazione-dati">Cancellazione Dati e Account</router-link>.
    </p>
  </PrivacySection>
</template>

<script>
import PrivacySection from '../PrivacySection.vue'

export default {
  name: 'UserRightsSection',
  components: {
    PrivacySection
  }
}
</script>

